import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export type StepperStateReducer = {
  position: number;
};

const initialState: StepperStateReducer = {
  position: 0,
};

export const stepperSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    setPosition: (state, action: PayloadAction<StepperStateReducer['position']>) => {
      if (action.payload >= 0) {
        state.position = action.payload;
      }
    },
    previousPosition: (state) => {
      state.position -= 1;
    },
    nextPosition: (state) => {
      state.position += 1;
    },
  },
});

//Export actions
export const { setPosition, nextPosition, previousPosition } = stepperSlice.actions;

//Definición de selectores
export const getCurrentPosition = (state: RootState) => state.stepper.position;

export default stepperSlice.reducer;
